import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import template from './dashboard-toolbar.hbs'
import topbar from './fullscreen-edit-top.hbs'
import Tooltip from 'scoreboard/components/tooltip'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import ImageWidget from '../widgets/image/image'
import InitiativeChart from '../widgets/initiative-chart/initiative-chart'
import InitiativeTimeline from '../widgets/initiative-timeline/initiative-timeline-widget'
import NotesWidget from '../widgets/notes/notes'
import ReportWidget from '../widgets/report/report-widget'
import TextWidget from '../widgets/text/text-widget'
import Perspective from '../widgets/perspective/perspective'
import DatasetFilterWidget from '../widgets/dataset-filter/dataset-filter-widget'
import DatasetTableWidget from '../widgets/dataset-table/dataset-table-widget'
import EmbeddedContent from '../widgets/embedded-content/embedded-content'
import Swap from './swap'
import appDisplay from 'scoreboard/components/app-display'
import SaveRequiredPrompt from './save-required-prompt'
import globals from 'scoreboard/components/globals'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import alignButtonTemplate from './align-button.hbs'
import distributeButtonTemplate from './distribute-button.hbs'
import layoutManager from 'scoreboard/components/layout-manager'
import constants from 'scoreboard/components/constants'
import DashboardSettings from './dashboard-settings'
import * as ChartWidgetAddMenu from 'scoreboard/dashboards/widgets/chart/chart-widget-add-menu'
import createBubbleShapeMenu from '../widgets/shape/create-bubble-shape-menu'
import createLineWidgetOption from '../widgets/shape/create-line-widget-option'
import createShapeWidgetMenu from '../widgets/shape/create-shape-widget-menu'
import createDatasetValueShapeMenu from '../widgets/shape/create-dataset-value-shape-menu'
import createGaugeMenu from '../widgets/create-gauge-menu'
import SpeedometerAddOption from '../widgets/speedometer/speedometer-add-option'
import { DEFAULT_SPEEDOMETER_PROPERTIES } from '../widgets/speedometer/speedometer-add-option'
import LinearGaugeAddOption	from '../widgets/linear-gauge/linear-gauge-add-option'
import { DEFAULT_LINEAR_GAUGE_PROPERTIES } from '../widgets/linear-gauge/linear-gauge-add-option'
import { LINEAR_GAUGE, SPEEDOMETER } from '../widgets/widget-type'
import isRtl from 'scoreboard/components/is-rtl'

import { isV5 } from 'scoreboard/components/version'

var Toolbar = Backbone.View.extend({

	// this.model is a Dashboard
	// this.options.dirty is a function that returns whether the dashboard is dirty
	// this.options.save is a function that saves the dashboard

	events: {
		'click .save': 'save',
		'click .toolbar-add': 'add',
		'click .toolbar-backward': 'undo',
		'click .toolbar-forward': 'redo',
		'click .toolbar-align': 'alignMenu',
		'click .toolbar-distribute': 'distributeMenu',
		'click .toolbar-settings': 'settings',
		'click .toolbar-normalscreen': 'normalscreen',
		// TODO: Remove when V5 is no longer supported (fullscreen method)
		'click .toolbar-fullscreen': 'fullscreen',
		'click .toolbar-swap': 'swap'
	},

	initialize: function (options) {
		this.options = options || {}
		this.canvas = options && options.canvas
		_.bindAll(this, 'normalscreen')
	},

	render: function () {
		this.$el.html(template(this.context()))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.on('canceled', () => this.preventRoute = true)
		return this
	},

	context () {
		let showSwap =
			// Can't swap items on a template copy
			!this.model.get('templateId') &&
			// #56207 Can't swap items in a form widget
			!this.options.formWidget

		// v6 gets rid of the fullscreen button, and form widgets don't have it
		// at all
		let showFullscreenButton = isV5() && !this.options.formWidget

		return _.extend({
			showSwap,
			showFullscreenButton
		}, this.model.toJSON())
	},

	save: function () {
		this.trigger('save')
	},

	add: function () {
		this.enablePreview = true
		// so we don't have any config or rich text tooltips hanging around
		this.canvas.deselectAll()

		this.addButton = this.$('.toolbar-add')

		_.invokeMap([this.addMenu, this.addTooltip], 'remove')

		this.addMenu = new AddMenu({
			model: this.model,
			canvas: this.canvas,
			addButton: this.addButton,
			widgetTypes: this.options.widgetTypes,
			menuSpace: this.menuSpace,
			getPeriodId: this.options.getPeriodId
		})

		// Fixes #54676
		let tooltipDirection = isRtl() ? 'left' : 'right'

		this.addTooltip = new Tooltip({
			attachTo: this.addButton,
			content: this.addMenu,
			placement: tooltipDirection,
			arrow: 'center',
			extraClass: 'add-widget has-bootslide-menu'
		})

		// Used to append an arrow to the right side of the add button. This resplaces the
		// tooltip's arrow which does not show due to the size of tooltip.
		this.addButton.addClass('has-tooltip')
		this.addTooltip.on('remove', () => {
			this.enablePreview = false
			this.addButton.removeClass('has-tooltip')
		})
		this.addMenu
			.on('preview', () => {
				if (this.enablePreview) this.addButton.removeClass('has-tooltip')
			})
			.on('endPreview', () =>  {
				if (this.enablePreview) this.addButton.addClass('has-tooltip')
			})
		this.addTooltip.render()
	},

	settings (e) {
		this.canvas.deselectAll() //clear selected objects

		let settingsMenu = new DashboardSettings({
			model: this.model,
			form: this.options.form,
			formWidget: this.options.formWidget
		})

		this.settingsTooltip = new Tooltip({
			attachTo: e.currentTarget,
			content: settingsMenu,
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu dashboard-settings'
		}).render()
	},

	undo: function () {
		if (this.$('.toolbar-backward').hasClass('is-disabled')) {
			return
		}
		this.canvas.history.undo()
	},

	redo: function () {
		if (this.$('.toolbar-forward').hasClass('is-disabled')) {
			return
		}
		this.canvas.history.redo()
	},

	// TODO: Remove when V5 is no longer supported (fullscreen method)
	fullscreen: function () {
		layoutManager.toggleTransitions(false) // no transitions needed in fullscreen mode
		this.canvas.$el.addClass('is-transitioning-fullscreen')
		layoutManager.changeLayout(constants.LAYOUT_DASHBOARD_EDIT_FULLSCREEN).then(() => {
			this.$el.append(topbar({chartName: this.model.get('label')}))
			this.trigger('updateButtons', 'fullscreen')
			this.trigger('resize')
			this.canvas.$el.removeClass('is-transitioning-fullscreen')
		})
		// If user exits fullscreen mode by using the browser's back button, the app goes to the
		// previous URL so it should return to the correct layout.
		// #20314 make sure we unbind any previous 'route' handling before rebinding it
		Backbone.history.off('route', this.normalscreen)
		Backbone.history.once('route', this.normalscreen)

		// #17668 clear any selections so things like tooltips won't be stuck
		// in the wrong position
		this.canvas && this.canvas.selection.clear()
	},

	fullscreenButtons(buttons) {
		this.$('.dashboard-fullscreen-topbar').prepend(buttons)
	},

	normalscreen: function () {
		// If bound route event is calling this method after a canceling changes (not exiting fullscreen),
		// prevent it from exiting fullscreen.
		if (this.preventRoute)  {
			this.preventRoute = false
			return
		}

		if (layoutManager.getLayout() == constants.LAYOUT_DASHBOARD_EDIT_FULLSCREEN) {
			layoutManager.toggleTransitions(false) // make sure transitions are turned off
			this.canvas.$el.addClass('is-transitioning-fullscreen')
			// Reset the left margin of the .nav-display-pane when returning to the
			// normal layout
			$('.nav-display-pane').css('margin-inline-start', $('.head-pane').width())
			layoutManager.changeLayout(constants.LAYOUT_STANDARD).then(() => {
				// The toolbar may have been destroyed (not in the DOM) by the time
				// the layout change is done, so make sure we're in the DOM before
				// doing anything with it
				if (this.$el.closest('body').length > 0) {
					this.trigger('resize')
					this.trigger('updateButtons', 'normalscreen', this.$('.save-cancel'))
				}

				$('.dashboard-fullscreen-topbar').remove()
				// Without setting a timeout here, in Firefox, the margin-left transition
				// for the .nav-display-pane is for some reason still applied when going
				// from 0px to $('.head-pane').width(). This timeout ensures the .disable-transitions
				// class isn't removed from the body until .nav-display-pane is put back in place.
				setTimeout(() => {
					layoutManager.toggleTransitions(true)
				}, 100)
				this.canvas.$el.removeClass('is-transitioning-fullscreen')
			})

			// #17668 clear any selections so things like tooltips won't be stuck
			// in the wrong position
			this.canvas && this.canvas.selection.clear()
		}
	},

	toggleUndo: function (enabled) {
		this.$('.toolbar-backward').toggleClass('is-disabled', !enabled)
	},

	toggleRedo: function (enabled) {
		this.$('.toolbar-forward').toggleClass('is-disabled', !enabled)
	},

	swap: function() {
		var fetchData = function () {
			return this.model.data.fetch({ calendarPeriodId: globals.periodId })
		}.bind(this)

		var createSwap = function () {
	 		var swap = new Swap({ model: this.model })
			swap.on('swap', this.trigger.bind(this, 'swap'))
			return swap
		}.bind(this)

		if (this.options.dirty()) {
			var prompt = new SaveRequiredPrompt()
			prompt.on('save', function() {
				this.options.save().then(function() {
					fetchData().then(function () {
						appDisplay.replaceDialog(createSwap())
					})
				}.bind(this))
			}.bind(this))

			appDisplay.dialog(prompt)
		} else {
			appDisplay.dialog(fetchData(), createSwap)
		}
	},

	alignMenu: function () {
		this._alignTooltip = new Tooltip({
			attachTo: this.$('.toolbar-align'),
			content: new AlignMenu({ canvas: this.canvas }),
			placement: 'below',
			arrow: 'center',
			extraClass: 'dashboard-control-menu-tooltip'
		}).render()
	},

	distributeMenu: function () {
		this._distributeTooltip = new Tooltip({
			attachTo: this.$('.toolbar-distribute'),
			content: new DistributeMenu({ canvas: this.canvas }),
			placement: 'below',
			arrow: 'center',
			extraClass: 'dashboard-control-menu-tooltip'
		}).render()
	},

	/**
	 * Updates this view with the amount of space available for the displaying of
	 * the toolbar menus.
	 * @param {Number} menuSpace.width
	 * @param {Number} menuSpace.height
	 */
	setMenuSpace(menuSpace) {
		this.menuSpace = menuSpace
	},

	remove: function() {
		$('body').removeClass('dashboard-fullscreen')
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.canvas, this.dashboardModel, this.covertButtonTooltips,
			this._alignTooltip, this._distributeTooltip, this.settingsTooltip], 'remove')
	}

})

var AddMenu = BootslideMenu.extend({
	initialize: function (opt) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.canvas = opt && opt.canvas
		this.options = opt || {}
	},

	menu: function () {
		var menuOptions = {
			label: i18n.get('dashboards.addWidget'),
			categories: [],
			layout: 'tiles'
		}

		var addIfEnabled = (type, menuCreator, key, id) => {
			if (_.includes(this.options.widgetTypes, type)) {
				let sectionIndex = _.findIndex(menuOptions.categories, o => o.key == key)
				if (sectionIndex < 0) {
					menuOptions.categories.push({
						key,
						label: i18n.get(key),
						target: [_.extend({}, menuCreator(this), { id })]
					})
				} else {
					menuOptions.categories[sectionIndex].target.push(_.extend({}, menuCreator(this), { id }))
				}
			}
		}

		function addScorecardBubble (menuSection) {
			addIfEnabled('scorecard-bubble',
				_.partial(createBubbleShapeMenu, 'scorecards'),
				menuSection,
				'scorecard-bubble')
		}

		// General
		addIfEnabled('image', ImageWidget.addMenu, 'admin.enable.exports.general', 'image')
		addIfEnabled('text', TextWidget.addMenu, 'admin.enable.exports.general', 'text')
		if (this.model.section === 'strategyMaps') {
			// Scorecard Bubble goes in top (and only) row for strategy maps
			addScorecardBubble('admin.enable.exports.general')
		}
		// Note: "Perspective" is only visible in Strategy Maps section
		addIfEnabled('perspective', Perspective.addMenu, 'admin.enable.exports.general')
		addIfEnabled('shape', createShapeWidgetMenu,
			'admin.enable.exports.general', 'shape')
		addIfEnabled('line', createLineWidgetOption,
			'admin.enable.exports.general', 'line')
		addIfEnabled('embedded-content', EmbeddedContent.addMenu, 'admin.enable.exports.general', 'embedded-content')

		// Scorecard
		if (this.model.section === 'dashboards') {
			// Scorecard Bubble goes in the Scorecards row for dashboards
			addScorecardBubble('scorecards.scorecards')
		}
		addIfEnabled('scorecard-speedometer',
			_.partial(createGaugeMenu, 'scorecards', SPEEDOMETER,
				SpeedometerAddOption, DEFAULT_SPEEDOMETER_PROPERTIES),
			'scorecards.scorecards',
			'scorecard-speedometer')
		addIfEnabled('scorecard-linear-gauge',
			_.partial(createGaugeMenu, 'scorecards', LINEAR_GAUGE,
				LinearGaugeAddOption, DEFAULT_LINEAR_GAUGE_PROPERTIES),
			'scorecards.scorecards',
			'scorecard-linear-gauge')
		addIfEnabled('notes', NotesWidget.addMenu.scorecards, 'scorecards.scorecards', 'scorecards-notes')

		// Initiative
		addIfEnabled('initiative-timeline', InitiativeTimeline.addMenu, 'initiatives.initiatives', 'initiatives-timeline')
		addIfEnabled('notes', NotesWidget.addMenu.initiatives, 'initiatives.initiatives', 'initiatives-notes')
		addIfEnabled('initiative-chart', InitiativeChart.addMenu, 'initiatives.initiatives', 'initiatives-chart')
		addIfEnabled('initiative-bubble',
			_.partial(createBubbleShapeMenu, 'initiatives'),
			'initiatives.initiatives',
			'initiative-bubble')
		addIfEnabled('initiative-speedometer',
			_.partial(createGaugeMenu, 'initiatives', SPEEDOMETER,
				SpeedometerAddOption, DEFAULT_SPEEDOMETER_PROPERTIES),
			'initiatives.initiatives', 'initiative-speedometer')
		addIfEnabled('initiative-linear-gauge',
			_.partial(createGaugeMenu, 'initiatives', LINEAR_GAUGE,
				LinearGaugeAddOption, DEFAULT_LINEAR_GAUGE_PROPERTIES),
			'initiatives.initiatives',
			'initiative-linear-gauge')

		// Dataset
		addIfEnabled('datasets', DatasetTableWidget.addMenu, 'datasets.datasets', 'datasets-add-table')
		addIfEnabled('datasets', createDatasetValueShapeMenu, 'datasets.datasets', 'datasets-add-value')
		addIfEnabled('datasets', DatasetFilterWidget.addMenu, 'datasets.datasets', 'datasets-add-filter')
		addIfEnabled('dataset-speedometer',
			_.partial(createGaugeMenu, 'datasets', SPEEDOMETER,
				SpeedometerAddOption, DEFAULT_SPEEDOMETER_PROPERTIES),
			'datasets.datasets', 'dataset-speedometer')
		addIfEnabled('dataset-linear-gauge',
			_.partial(createGaugeMenu, 'datasets', LINEAR_GAUGE,
				LinearGaugeAddOption, DEFAULT_LINEAR_GAUGE_PROPERTIES),
			'datasets.datasets',
			'dataset-linear-gauge')

		// Charts
		addIfEnabled('charts', ChartWidgetAddMenu.newChart, 'admin.group.category.chartsAndReports', 'charts-add-new')
		addIfEnabled('charts', ChartWidgetAddMenu.saved, 'admin.group.category.chartsAndReports', 'charts-add-existing')

		// Reports
		addIfEnabled('report', ReportWidget.addMenu.newReport, 'admin.group.category.chartsAndReports', 'reports-add-new')
		addIfEnabled('report', ReportWidget.addMenu.saved, 'admin.group.category.chartsAndReports', 'reports-add-existing')

		return menuOptions
	}
})

var AlignMenu = Backbone.View.extend({
	className: 'align-menu',

	initialize: function (opt) {
		this.canvas = opt.canvas
	},

	render: function () {
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		var canvas = this.canvas
		var buttons = alignOptions.map(function (option) {
			return $(alignButtonTemplate({
					alignment: option,
					message: 'dashboards.align.' + option,
					icon: 'wob-align-' + option
				}))
				.on('click', function () {
					canvas.align($(this).data().alignment)
				})
		})

		this.$el.append(buttons)

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}
})

const DistributeMenu = Backbone.View.extend({
	className: 'distribute-menu',

	initialize: function (opt) {
		this.canvas = opt.canvas
	},

	render: function () {
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		var canvas = this.canvas
		var buttons = distributeOptions.map(function (option) {
			return $(distributeButtonTemplate({
					alignment: option,
					message: 'dashboards.distribute.' + option,
					icon: 'wob-distribute-' + option
				}))
				.on('click', function () {
					let alignment = $(this).data().alignment
					if (alignment === 'even') {
						canvas.selection.distribute('horizontal')
						canvas.selection.distribute('vertical')
					} else {
						canvas.selection.distribute(alignment)
					}
				})
		})

		this.$el.append(buttons)

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}
})

var alignOptions = ['left', 'center', 'right', 'top', 'middle', 'bottom']
const distributeOptions = ['horizontal', 'vertical', 'even']


export default Toolbar

Toolbar.__filename__ = 'dashboards/edit/dashboard-toolbar.js'
